import AppListing from '../app-components/Listing/AppListing';

Vue.component('work-day-listing', {
    mixins: [AppListing]
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/work-day/Listing.js